export default __webpack_public_path__ + "static/media/notification.9b20c86c.mp3";